module.exports = __webpack_public_path__ + "static/media/021-winter.ac6b6305.svg";